import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";

import Sidebar from "~/components/Sidebar";
import SidebarBusyOverlay from "~/components/Sidebar/components/SidebarBusyOverlay";
import { CLIENTS_QUOTAS_QUERY_KEY } from "~/modules/client/api/quota/quotaQueries.ts";
import CreateQuotaForm
	from "~/modules/client/components/ClientDetailsView/components/QuotasTabContent/components/CreateQuotaSidebar/components/CreateQuotaForm.tsx";
import { useClientsProjects } from "~/modules/project/api/project/projectQueries.ts";

type Props = {
	clientId: string;
	isOpen: boolean;
	onClose: () => void;
};

const CreateQuotaSidebar = ({
	clientId,
	isOpen,
	onClose,
}: Props) => {
	const { isLoading: projectsIsLoading } = useClientsProjects(clientId);
	const queryClient = useQueryClient();
	const handleSuccess = useCallback(async () => {
		await queryClient.refetchQueries({ queryKey: CLIENTS_QUOTAS_QUERY_KEY(clientId) });
		queryClient.invalidateQueries();


		onClose();
	}, [clientId, onClose, queryClient]);

	return (
		<Sidebar closeOnOutsideClick={false}
				 open={isOpen}
				 setOpen={onClose}>
			{isOpen && projectsIsLoading && <SidebarBusyOverlay />}
			{isOpen && !projectsIsLoading && <CreateQuotaForm clientId={clientId}
															  onCancel={onClose}
															  onSuccess={handleSuccess} />}
		</Sidebar>
	);
};

export default CreateQuotaSidebar;
